// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0ffd0a4e","144":"2294f03d","193":"8de549c3","237":"3ef83454","289":"41b38ce7","453":"48760631","546":"655ad90c","630":"cb62c630","742":"ddc1030c","806":"2b00a1c0"}[chunkId] + ".chunk.js";
};